<template>
  <div class="table__empty">
    <!-- <div class="table__empty-img">
            <img src="/images/table-empty.svg" alt="">
        </div> -->
    <div class="table__empty-img">
      <img
        v-if="icon === 'table'"
        class="table__empty-img-ill"
        src="/images/table-empty.svg"
        alt=""
      />
      <img
        v-else-if="icon === 'comment'"
        class="table__empty-img-ill"
        src="/images/comment-empty.svg"
        alt=""
      />
      <img
        class="table__empty-img-loop"
        src="/images/empty-img-loop.svg"
        alt=""
      />
    </div>
    <div v-if="!withoutTitle" class="table__empty-title h3">
      <template v-if="title && title.length > 0"> {{ title }}</template>
      <template v-else>הרשימה ריקה!</template>
    </div>
    <div class="table__empty-text">
      {{ text }}
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'TheEmptyTable',
  components: {},

  props: {
    icon: {
      type: String,
      default: 'table'
    },
    withoutTitle: {
      type: Boolean,
      default: false
    },
    title: String,
    text: String
  }
};
</script>
